(() => {
  let frame = 0;
  let announcementIsHidden = window.scrollY > 40;

  const syncAnnouncementState = () => {
    const header = document.getElementById('nav-wrapper');
    const announcements = document.querySelectorAll('[data-aoy-announcement-bar]');

    if (window.scrollY <= 32) {
      announcementIsHidden = false;
    } else if (window.scrollY > 40) {
      announcementIsHidden = true;
    }

    header?.classList.toggle('aoy-header-compact', announcementIsHidden);

    announcements.forEach((announcement) => {
      if (!announcement.style.getPropertyValue('--aoy-announcement-height')) {
        announcement.style.setProperty(
          '--aoy-announcement-height',
          `${announcement.scrollHeight}px`,
        );
      }

      announcement.classList.toggle('aoy-announcement-hidden', announcementIsHidden);
    });
  };

  const queueAnnouncementSync = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      syncAnnouncementState();
    });
  };

  syncAnnouncementState();
  window.addEventListener('scroll', queueAnnouncementSync, { passive: true });
  window.addEventListener('resize', queueAnnouncementSync, { passive: true });
  document.addEventListener('shopify:section:load', queueAnnouncementSync);
})();

(() => {
  const searchTriggers = document.querySelectorAll(
    '[data-header-action="search"][data-tooltip-trigger]',
  );

  searchTriggers.forEach((trigger) => {
    const syncSearchState = () => {
      trigger.setAttribute('aria-expanded', trigger.hasAttribute('open') ? 'true' : 'false');
    };

    syncSearchState();
    new MutationObserver(syncSearchState).observe(trigger, {
      attributes: true,
      attributeFilter: ['open'],
    });
  });

  const mobileMenuTrigger = document.querySelector('[data-mobile-menu-trigger]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');

  if (mobileMenuTrigger && mobileMenu) {
    let wasOpen = mobileMenuTrigger.hasAttribute('open');

    const syncMobileMenuState = () => {
      const isOpen = mobileMenuTrigger.hasAttribute('open');
      mobileMenuTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        mobileMenu.setAttribute('aria-hidden', 'false');
        if (!wasOpen) mobileMenuClose?.focus?.();
      } else {
        if (wasOpen) mobileMenuTrigger.focus?.();
        mobileMenu.setAttribute('aria-hidden', 'true');
      }

      wasOpen = isOpen;
    };

    syncMobileMenuState();
    new MutationObserver(syncMobileMenuState).observe(mobileMenuTrigger, {
      attributes: true,
      attributeFilter: ['open'],
    });

    mobileMenuClose?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (mobileMenuTrigger.hasAttribute('open')) mobileMenuTrigger.click();
    });
  }

  const cartTrigger = document.querySelector('button[data-header-action="cart"]');
  const cartDrawer = document.getElementById('mini-cart');

  if (!cartTrigger || !cartDrawer) return;

  const syncCartState = () => {
    const isOpen = cartDrawer.classList.contains('open');
    const cartForm = cartDrawer.querySelector('.mini-cart__sidebar');

    cartTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    cartDrawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    cartForm?.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  };

  syncCartState();
  new MutationObserver(syncCartState).observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['class'],
  });
})();
